// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__skU4c","notes":"Notes_notes__3FJtQ","note":"Notes_note___1Z8o","markdown":"Notes_markdown__2hkyJ"};